export enum LocalStorageKeys{
    SSE_KEY="sse-key",
    JOB_STATUS="job-status" 
}